<template>
    <transition-group name="toast-slide" tag="div" class="modern-toast-container">
        <div
            v-for="toast in toasts"
            :key="toast.id"
            :class="['modern-toast', `toast-${toast.type}`]"
            @click="removeToast(toast.id)"
        >
            <div class="toast-icon-wrapper">
                <i :class="iconClass(toast.type)"></i>
            </div>
            <div class="toast-content">
                <span class="toast-message">{{ toast.message }}</span>
            </div>
            <button class="toast-close" @click.stop="removeToast(toast.id)">
                <i class="fas fa-times"></i>
            </button>
            <div class="toast-progress" :style="{ animationDuration: toast.duration + 'ms' }"></div>
        </div>
    </transition-group>
</template>

<script>
export default {
    data() {
        return {
            toasts: [],
            nextId: 0,
        }
    },
    methods: {
        addToast(message, type = "info", duration = 4000) {
            const id = this.nextId++
            this.toasts.push({ id, message, type, duration })
            setTimeout(() => this.removeToast(id), duration)
        },
        removeToast(id) {
            this.toasts = this.toasts.filter((t) => t.id !== id)
        },
        iconClass(type) {
            const icons = {
                success: "fas fa-check-circle",
                error: "fas fa-exclamation-circle",
                warning: "fas fa-exclamation-triangle",
                info: "fas fa-info-circle",
            }
            return icons[type] || icons.info
        },
    },
}
</script>

<style lang="scss">
.modern-toast-container {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 99999;
    display: flex;
    flex-direction: column;
    gap: 10px;
    pointer-events: none;
    max-width: 400px;
    width: calc(100% - 40px);
}
.modern-toast {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 12px;
    background: white;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #e2e8f0;
    pointer-events: all;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);

    &.toast-success {
        border-left: 4px solid #10b981;
        .toast-icon-wrapper { color: #10b981; background: #ecfdf5; }
        .toast-progress { background: #10b981; }
    }
    &.toast-error {
        border-left: 4px solid #ef4444;
        .toast-icon-wrapper { color: #ef4444; background: #fef2f2; }
        .toast-progress { background: #ef4444; }
    }
    &.toast-warning {
        border-left: 4px solid #f59e0b;
        .toast-icon-wrapper { color: #f59e0b; background: #fffbeb; }
        .toast-progress { background: #f59e0b; }
    }
    &.toast-info {
        border-left: 4px solid #3b82f6;
        .toast-icon-wrapper { color: #3b82f6; background: #eff6ff; }
        .toast-progress { background: #3b82f6; }
    }
}
.toast-icon-wrapper {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    flex-shrink: 0;
}
.toast-content {
    flex: 1;
    min-width: 0;
}
.toast-message {
    font-size: 13px;
    font-weight: 500;
    color: #1e293b;
    line-height: 1.4;
    display: block;
    word-break: break-word;
}
.toast-close {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border: none;
    background: transparent;
    color: #94a3b8;
    cursor: pointer;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    transition: all 0.15s ease;

    &:hover {
        background: #f1f5f9;
        color: #475569;
    }
}
.toast-progress {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    width: 100%;
    opacity: 0.6;
    animation: toastProgress linear forwards;
    transform-origin: left;
    border-radius: 0 0 0 12px;
}
@keyframes toastProgress {
    from { transform: scaleX(1); }
    to { transform: scaleX(0); }
}

/* Transitions */
.toast-slide-enter-active {
    transition: all 0.35s cubic-bezier(0.21, 1.02, 0.73, 1);
}
.toast-slide-leave-active {
    transition: all 0.25s cubic-bezier(0.06, 0.71, 0.55, 1);
}
.toast-slide-enter {
    opacity: 0;
    transform: translateX(40px) scale(0.96);
}
.toast-slide-leave-to {
    opacity: 0;
    transform: translateX(40px) scale(0.96);
}
.toast-slide-move {
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@media (max-width: 480px) {
    .modern-toast-container {
        top: 12px;
        right: 12px;
        left: 12px;
        width: auto;
        max-width: none;
    }
}
</style>
